import React from 'react';
import BaseEChart from './BaseEChart';
import { buildGroupedFinancialOption } from './performanceTrendOptions';
import type { GroupedFinancialChartData } from '@app-types/performanceTrends';

export interface FinancialGroupedBarChartProps {
  data: GroupedFinancialChartData;
  height?: number;
  ariaLabel?: string;
}

/**
 * Shared grouped bar chart for Balance sheet, Cash flow and R&D sections
 * (see PT03 / section 6.2–6.4). Supports negative values and a zero line.
 * Renders through BaseEChart only.
 */
const FinancialGroupedBarChart: React.FC<FinancialGroupedBarChartProps> = ({
  data,
  height = 170,
  ariaLabel,
}) => (
  <BaseEChart
    option={buildGroupedFinancialOption(data)}
    height={height}
    ariaLabel={ariaLabel ?? '財務指標の推移チャート'}
    animate
  />
);

export default FinancialGroupedBarChart;
